var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 4.66675L6.77678 8.47704C7.21756 8.78559 7.43795 8.93986 7.67767 8.99962C7.88943 9.0524 8.1109 9.0524 8.32265 8.99962C8.56238 8.93986 8.78277 8.78559 9.22355 8.47704L14.6668 4.66675M4.5335 13.3334H11.4668C12.5869 13.3334 13.147 13.3334 13.5748 13.1154C13.9511 12.9237 14.2571 12.6177 14.4488 12.2414C14.6668 11.8136 14.6668 11.2535 14.6668 10.1334V5.86675C14.6668 4.74664 14.6668 4.18659 14.4488 3.75877C14.2571 3.38244 13.9511 3.07648 13.5748 2.88474C13.147 2.66675 12.5869 2.66675 11.4668 2.66675H4.5335C3.41339 2.66675 2.85334 2.66675 2.42552 2.88474C2.04919 3.07648 1.74323 3.38244 1.55148 3.75877C1.3335 4.18659 1.3335 4.74664 1.3335 5.86675V10.1334C1.3335 11.2535 1.3335 11.8136 1.55148 12.2414C1.74323 12.6177 2.04919 12.9237 2.42552 13.1154C2.85334 13.3334 3.41339 13.3334 4.5335 13.3334Z",
    stroke: "#667085",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail01);
export default __webpack_public_path__ + "static/media/mail-01.7e0130a9f372fd4a8f00dd8f72fc6f6a.svg";
export { ForwardRef as ReactComponent };